import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Alert } from 'components/common';
import { Box } from 'components/common/box';
import { ProfileAuthTwoFactorActive, ProfileAuthTwoFactorInfo } from '.';
import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

interface Props {
  isSharedConfiguration?: boolean;
  title?: string;
}

const ProfileAuthTwoFactor = ({
  isSharedConfiguration = false,
  title
}: Props) => {
  const {
    messages,
    serverConfig: { authSharedTwoFactor },
    user
  } = useReduxState();

  const { data, loading, error, updateData } = useApiData({
    url:
      '/auth/totp/status' +
      (isSharedConfiguration ? '?isSharedConfigured=true' : ''),
    onlyIf: Boolean(user?.id)
  });

  const affectedBySharedTwoFactor =
    user &&
    !isSharedConfiguration &&
    authSharedTwoFactor.isEnabled &&
    authSharedTwoFactor.isConfigured &&
    (!authSharedTwoFactor.conditions?.length ||
      attributesConditionsMatch({
        conditions: authSharedTwoFactor.conditions,
        customAttributeValues: user.customAttributes,
        omitCustomAttributes: false,
        user
      }));

  return (
    <div className="two-factor">
      <Box
        loading={loading}
        title={title || messages.authTwoFactorAuthentication}
      >
        {error ? (
          <Alert text={messages.commonError} type="error-light" />
        ) : data?.isActive ? (
          <div className="active">
            <ProfileAuthTwoFactorActive
              affectedBySharedTwoFactor={affectedBySharedTwoFactor}
              isSharedConfiguration={isSharedConfiguration}
              numberOfBackupCodes={data?.numberOfBackupCodes || 0}
              onUpdate={updateData}
            />
          </div>
        ) : affectedBySharedTwoFactor ? (
          <Alert
            text={`${messages.authTwoFactorAuthenticationSharedInUse} ${messages.authTwoFactorAuthenticationSharedBlocking}`}
            type="info"
          />
        ) : (
          <div className="setup">
            <ProfileAuthTwoFactorInfo
              isSharedConfiguration={isSharedConfiguration}
              onActivated={updateData}
              secret={data?.newSecret}
            />
          </div>
        )}
      </Box>

      <style jsx>{`
        .disable {
          margin-top: 15px;
        }
        .activate {
          margin-top: 15px;
        }
      `}</style>
    </div>
  );
};

export default ProfileAuthTwoFactor;
